<template>
  <b-form-group
    label="Renk"
    :label-for="iKey + '_id_table_colors'"
  >
    <v-select
      :id="iKey + '_id_table_colors'"
      v-model="dataItem[iKey].id_table_colors"
      placeholder="Renk"
      :options="colors"
      label="title"
      :reduce="item => item.id"
    >
      <template v-slot:selected-option="option">
        <div class="d-flex align-items-center">
          <div
            class="table-color-select-item"
            :style="'background-color: ' + option.hexcode"
          />
          <div>
            {{ option.title }}
          </div>
        </div>
      </template>
      <template v-slot:option="option">
        <div class="d-flex align-items-center">
          <div
            class="table-color-select-item"
            :style="'background-color: ' + option.hexcode"
          />
          <div>
            {{ option.title }}
          </div>
        </div>
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ColorSelect',
  components: {
    BFormGroup,
    vSelect,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['productItems/dataList']
    },
    colors() {
      return this.$store.getters['tableColors/dataList']
    },
  },
}
</script>
<style>
.table-color-select-item{
  width: 20px !important;
  height: 20px !important;
  display: block !important;
  border-radius: 50% !important;
  margin-right: 4px;
}
</style>
